export { PaperAirplane as default } from './PaperAirplane';
